import React, { useState } from 'react';
import { ALL_VALID_IMAGE_TYPES } from '../../Constants/MainKeys';
import MainService from '../../Services/MainService';
import AlertService from '../../Services/AlertService';

const ImageUploadComponent = ({ cb, multiple = false, field = "" }) => {

  const [fileReadPercent, setFileReadPercent] = useState(0);

  const uploadFile = async (files) => {
    const fileEntities = [];
    if (files && files.length) {
      for (let i in files) {
        const file = files[i];
        if (file && typeof file === "object") {
          const fileName = file.name;
          await MainService.readFile(file, ALL_VALID_IMAGE_TYPES, setFileReadPercent)
            .then(uploadedFile => {
              fileEntities.push({
                fileName,
                file,
                uploadedFile,
              });
              cb && cb(fileEntities, field);
            })
            .catch(error => error && AlertService.alert("warning", error));
        }
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const { files } = event.dataTransfer;
    if (files.length) {
      uploadFile(files);
    }
  };

  const handleClick = () => {
    document.getElementById(`file-upload-${field}`).click();
  };

  return (
    <div className="position-relative mb-3 form-group">

      <div
        className="drag-drop-area p-3 text-center d-flex justify-content-center align-items-center flex-column"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={handleClick}
        style={{ borderRadius: '8px', border: "3px dashed #dddddd", minHeight: '100px', cursor: 'pointer' }}
      >
        <div>
          <p className="text-muted mb-0 " style={{ fontSize: "16px", fontWeight: "500" }}>Click or Drag & Drop file here</p>
          <div className='d-flex'>
            <small className="text-muted mb-0 d-block" style={{ fontSize: "12px" }}>
              All valid file types are:&nbsp;
            </small>
            <div className='d-flex justify-content-center' style={{ gap: "5px" }}>
              {
                ALL_VALID_IMAGE_TYPES.map((item, index) => {
                  return <small key={index} className="text-muted mb-0 d-block" style={{ fontSize: "12px" }}>
                    <span style={{ fontWeight: "500" }}>.{item}</span>
                  </small>
                })
              }
            </div>
          </div>
          <small className="text-muted mb-0 d-block mt-2" style={{ fontSize: "12px" }}>Maximum file size: <span style={{ fontWeight: "500" }}>20MB</span></small>
        </div>
        <input
          id={`file-upload-${field}`}
          type="file"
          multiple={multiple}
          accept="image/*"
          onChange={(e) => uploadFile(e.target.files)}
          style={{ display: 'none' }}
        />

        {fileReadPercent > 0 && fileReadPercent < 100 && (
          <div className="mt-2">
            <p>Uploading: {fileReadPercent}%</p>
          </div>
        )}
      </div>

    </div>
  );
};

export default ImageUploadComponent;